import { IStorageService } from "../../platform/services/storage/StorageService";

export interface UploadImageParams {
    multiple: boolean;
    accept?: string;
}

export const PRESIGNED_URL_EXPIRATION_SECONDS = 900;

export class FileProvider {
    form: HTMLFormElement;
    input: HTMLInputElement;
    anchor: HTMLAnchorElement;
    signedUrlsMap = new Map<string, string>();
    signedUrlsClearTimeoutMap = new Map<string, number>();
    private storageService: IStorageService;

    constructor(storageService: IStorageService) {
        this.storageService = storageService;

        this.form = document.createElement("form");
        this.form.innerHTML = '<input type="file" style="position: absolute; top: 9999px" aria-hidden="true">';
        this.input = this.form.childNodes[0] as HTMLInputElement;
        this.anchor = document.createElement('a');
        this.anchor.target = "_blank";
        const otherRoot = document.getElementById('other') || document.body;
        otherRoot.appendChild(this.form);
        otherRoot.appendChild(this.anchor);
    }

    uploadImage = ({multiple,}: UploadImageParams, cb: (files: FileList | null) => void) => {
        this.input.accept = "image/*";
        this.input.multiple = multiple;
        this.triggerUploadDialog(cb)
    }

    uploadFile = ({multiple, accept}: UploadImageParams, cb: (files: FileList | null) => void) => {
        this.input.accept = accept || "*/*";
        this.input.multiple = multiple || false;
        this.triggerUploadDialog(cb)
    }

    triggerUploadDialog = (cb: (files: FileList | null) => void) => {
        const fileLoadHandler = (event: Event) => {
            const input = event.target as HTMLInputElement;
            cb(input.files);
            this.form.reset();
        };

        this.input.addEventListener('change', fileLoadHandler, {once: true});
        this.input.click();
    }

    getSignedUrl = async (s3FilePath: string) => {
        if (!this.signedUrlsMap.has(s3FilePath)) {
            const preSignedUrl = await this.storageService.getSignedUrl(s3FilePath, PRESIGNED_URL_EXPIRATION_SECONDS);
            this.signedUrlsMap.set(s3FilePath, preSignedUrl.toString());

            if (this.signedUrlsClearTimeoutMap.has(s3FilePath)) {
                clearTimeout(this.signedUrlsClearTimeoutMap.get(s3FilePath));
            }
            this.signedUrlsClearTimeoutMap.set(
                s3FilePath,
                setTimeout(() => this.clearCacheFor(s3FilePath), PRESIGNED_URL_EXPIRATION_SECONDS * 1000) as unknown as number,
            )
        }
        return this.signedUrlsMap.get(s3FilePath)!;
    }

    getImageUrlIfExists= (s3FilePath: string) => {
        if (!this.signedUrlsMap.has(s3FilePath)) {
            return false;
        }
        return this.signedUrlsMap.get(s3FilePath)!;
    }

    clearCacheFor = (s3FilePath: string) => {
        if (this.signedUrlsClearTimeoutMap.has(s3FilePath)) {
            clearTimeout(this.signedUrlsClearTimeoutMap.get(s3FilePath));
        }
        this.signedUrlsMap.delete(s3FilePath);
    }

    destroy = () => {
        this.form.remove();
    }

    downloadFile = async (src: string, fileName?: string) => {
        this.anchor.download = fileName ? fileName : src.split('/').pop()!;
        try {
            const response = await fetch(src);
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            this.anchor.href = url;

            const event = new MouseEvent("click");
            this.anchor.dispatchEvent(event);

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);

            // In case of an error, open the file in a new tab
            this.anchor.href = src;
            const event = new MouseEvent("click");
            this.anchor.dispatchEvent(event);
        }
    }
}


